import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

export const userManager = new UserManager({
    accessTokenExpiringNotificationTimeInSeconds: 10,
    authority: process.env.REACT_APP_URL_LOGIN || '',
    automaticSilentRenew: true,
    client_id: process.env.REACT_APP_CLIENT_ID || '',
    client_secret: process.env.REACT_APP_CLIENT_SECRET || '',
    loadUserInfo: true,
    redirect_uri: process.env.REACT_APP_REDIRECT_URI || '',
    silent_redirect_uri: process.env.REACT_APP_REDIRECT_URI + '/inicio',
    userStore: new WebStorageStateStore({ store: window.localStorage }),
});